import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

const installPrimeDatePickerFlickerFix = (): void => {
  if (typeof document === 'undefined') {
    return;
  }

  let suppressDatePickerInputFocusUntil = 0;

  const isDateCellTarget = (target: EventTarget | null): boolean => {
    const element = target as HTMLElement | null;
    return !!element?.closest('.p-datepicker-calendar td, [data-pc-section="daycell"]');
  };

  const isDatePickerInput = (target: EventTarget | null): target is HTMLElement => {
    const element = target as HTMLElement | null;
    if (!element) {
      return false;
    }
    return (
      element.matches('.p-datepicker-input') ||
      element.matches('input[aria-haspopup="dialog"]')
    );
  };

  document.addEventListener(
    'pointerdown',
    (event: Event) => {
      if (!isDateCellTarget(event.target)) {
        return;
      }
      suppressDatePickerInputFocusUntil = Date.now() + 250;
    },
    true,
  );

  document.addEventListener(
    'focusin',
    (event: Event) => {
      if (!isDatePickerInput(event.target)) {
        return;
      }
      if (Date.now() > suppressDatePickerInputFocusUntil) {
        return;
      }
      // PrimeNG may re-focus the trigger input after day select; blur it to avoid overlay re-open flicker.
      requestAnimationFrame(() => {
        const active = document.activeElement;
        if (active instanceof HTMLElement && isDatePickerInput(active)) {
          active.blur();
        }
      });
    },
    true,
  );
};

installPrimeDatePickerFlickerFix();
bootstrapApplication(App, appConfig).catch((err) => console.error(err));
